// src/slices/subscription/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// 🔹 Get all subscriptions
export const getSubscriptions = createAsyncThunk("subscription/getAll", async ({ page = 1, limit = 10, search = "" }, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}subscriptions`, { params: { page, limit, search } });

    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});
export const createSubscription = createAsyncThunk("subscription/create", async (data, { rejectWithValue }) => {
  try {
    const res = await axios.post(`${API_URL}/subscription`, data);

    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// 🔹 Get subscription by id
export const getSubscriptionById = createAsyncThunk("subscription/getById", async (id, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}subscriptions/${id}`);
    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// 🔹 Delete subscription
export const deleteSubscription = createAsyncThunk("subscription/delete", async (id, { rejectWithValue }) => {
  try {
    const res = await axios.delete(`${API_URL}subscriptions/${id}`);
    return { id, ...res.data };
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// 🔹 Toggle subscription active/inactive
export const toggleSubscription = createAsyncThunk("subscription/toggle", async (id, { rejectWithValue }) => {
  try {
    const res = await axios.patch(`${API_URL}subscriptions/${id}/toggle`);
    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});
